import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@digital-hig/mui/dist/Typography';
import styled from 'styled-components';
import SvgCtaArrowRight from '@digital-hig/icon/lib/esm/icons/cta-arrow-right';
import GettingStartedPanelCard from './gettingStartedPanelCard';
import Carousel from './carousel';
import ProductIcons from './productIcons';
import { triggerManualLinkClick } from '../common/analyticsApi';

const GetStartedPanel = ({ data, singleDisplay }) => {
  if (singleDisplay) {
    return (
      <div>
        <IconWrapper>
          <ProductIcons products={data[0].meta.products} />
        </IconWrapper>
        <Typography variant="headline-small">{data[0].title}</Typography>
        <Typography variant="body-copy-medium">{data[0].shortDescription}</Typography>
        <CardActions
          className="carouselGroupButton"
        >
          <Button
            variant="link-button"
            startIcon={<SvgIcon><SvgCtaArrowRight /></SvgIcon>}
            component={Link}
            to={data[0].uri}
            onClick={() => triggerManualLinkClick({ linkTitle: `View the quick start guide for ${data[0]?.meta?.products?.map((p) => p?.displayName).join(', ')}` })}
          >
            View the quick start guide
          </Button>
        </CardActions>
      </div>
    );
  }
  return (
    <Carousel
      options={{
        mobileCount: 1, tabletCount: 2, desktopCount: 3, scrollBy: 'tray',
      }}
      title={(
        <Typography
          variant="headline-small"
          component="span"
        >
          Getting started
        </Typography>
      )}
    >
      { data.map((item) => (
        <GettingStartedPanelCard title={item.title} shortDescription={item.shortDescription} viewQuickGuideUrl={item.uri} products={item.meta.products} singleDisplay={singleDisplay} />
      )) }
    </Carousel>
  );
};

GetStartedPanel.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]).isRequired,
  singleDisplay: PropTypes.bool,
};

GetStartedPanel.defaultProps = {
  singleDisplay: false,
};

const IconWrapper = styled.div`
  padding-bottom: 24px;
`;

export default GetStartedPanel;
